import { intersection } from "lodash";

import type { PollService } from "@busbud/core-types";
import type { TicketType } from "@busbud/int-schemas";

import type { LegIndex } from "@app/constants/trip";
import { OUTBOUND_LEG_INDEX, RETURN_LEG_INDEX } from "@app/constants/trip";

import { getLegSegments } from "./get-leg-segments";
import { isRoundtrip } from "./is-roundtrip";

export const getTripTicketTypes = (
  // TODO: adjust to use Segment. There are differences between ticket_types of `NapiV2CartSegment` and `RelatedPublicSegment`. Making the base `Segment` not being accepted
  segments: { ticket_types: TicketType[] | null }[]
): TicketType[] =>
  intersection(...segments.map(({ ticket_types }) => ticket_types));

type GetTripTicketTypesPerLeg = {
  outbound_ticket_types: TicketType[];
  return_ticket_types: TicketType[] | null;
};
export const getTripTicketTypesPerLeg = (
  trip: PollService.API.PublicTrip
): GetTripTicketTypesPerLeg => ({
  outbound_ticket_types: getLegTicketTypes(trip, OUTBOUND_LEG_INDEX),
  return_ticket_types: isRoundtrip(trip)
    ? getLegTicketTypes(trip, RETURN_LEG_INDEX)
    : null
});

const getLegTicketTypes = (
  trip: PollService.API.PublicTrip,
  leg_index: LegIndex
) => {
  const leg_segments = getLegSegments(trip, leg_index);
  return getTripTicketTypes(leg_segments);
};
